import React, { useState, useEffect, useCallback, useRef } from "react";
import api from "../../../services/api";
import { Html5QrcodeScanner } from "html5-qrcode";
import { Background, Container, Titulo, Hr, BigButton, H4, Table, ContentWrapper, Panel, P, Icone, Circle, InputLabel } from "./style";
import { Toast } from "../../../services/SwalTemplates";
import GoBack from "../../../components/GoBack";
import { checkForCamera } from "../../../utils/cameraCheck";
import { formatDatesHoras } from "../../../utils/formatDates";
import RegisterManual from "../../../components/Modal/Rh/ControleCestas/Register";
import { IoMdCheckmark } from "react-icons/io";

export default function RegisterRetiradas() {
  const [showScanner, setShowScanner] = useState(true);
  const [hasCamera, setHasCamera] = useState(false);
  const [retiradas, setRetiradas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [retiradaCadastrada, setRetiradaCadastrada] = useState(null);
  const scanLockedRef = useRef(false);
  const SCAN_COOLDOWN_MS = 3500;
  const [showManualModal, setShowManualModal] = useState(false);
  const [codigo, setCodigo] = useState("");
  const scannerId = "qr-code-scanner";
  const [totalCestas, setTotalCestas] = useState(0);
  const [totalCestasRetiradas, setTotalCestasRetiradas] = useState(0);
  const [totalBrinquedos, setTotalBrinquedos] = useState(0);
  const [totalBrinquedosRetirados, setTotalBrinquedosRetirados] = useState(0);

  const fetchRetiradas = useCallback(() => {
    api
      .get(`/rh/controle-cestas/resumo`)
      .then((response) => {
        const items = response.data.items || [];
        const retirados = items
          .filter((item) => item.retirou_cesta || item.retirou_brinquedo)
          .map((item) => {
            const allRetiradas = [];
            if (item.retirou_cesta) {
              allRetiradas.push({
                id: `${item.matricula}-cesta`,
                matricula: item.matricula,
                nome: item.nome_colaborador,
                tipo: "Cesta",
                data: item.data_retirada_cesta,
              });
            }
            if (item.retirou_brinquedo) {
              allRetiradas.push({
                id: `${item.matricula}-brinquedo`,
                matricula: item.matricula,
                nome: item.nome_colaborador,
                tipo: "Brinquedo",
                data: item.data_retirada_brinquedo,
              });
            }
            return allRetiradas;
          })
          .flat()
          .sort((a, b) => new Date(b.data) - new Date(a.data));

        setRetiradas(retirados);
      })
      .catch((error) => {
        console.error("Erro ao buscar últimas retiradas:", error);
      });
  }, []);
  const carregarTotais = () => {
    api
      .get(`/rh/controle-cestas/list-totais`)
      .then((response) => {
        const items = response.data.item || [];
        console.log(response.data);
        setTotalCestas(items.total_cestas || 0);
        setTotalCestasRetiradas(items.total_cestas_retiradas || 0);
        setTotalBrinquedos(items.total_brinquedos || 0);
        setTotalBrinquedosRetirados(items.total_brinquedos_retirados || 0);
      })
      .catch((error) => {
        console.error("Erro ao buscar total de retiradas:", error);
      });
  };
  useEffect(() => {
    const checkCamera = async () => {
      const cameraExists = await checkForCamera();
      setHasCamera(cameraExists);
      if (!cameraExists) {
        setShowScanner(false);
      }
    };
    checkCamera();
    fetchRetiradas();
    carregarTotais();
  }, [fetchRetiradas]);

  useEffect(() => {
    if (showScanner && hasCamera) {
      const scanner = new Html5QrcodeScanner(
        scannerId,
        {
          qrbox: {
            width: 175,
            height: 175,
          },
          fps: 10,
        },
        false
      );
      scanner.render(handleScan, handleError);
      return () => {
        scanner.clear().catch((error) => {
          console.error("Falha ao limpar o scanner.", error);
        });
      };
    }
  }, [showScanner, hasCamera]);

  useEffect(() => {
    if (codigo === "") return;

    const timeout = setTimeout(() => {
      registrarRetiradaPorCodigo(codigo);
      setCodigo("");
    }, 1000);

    return () => clearTimeout(timeout);
  }, [codigo]);

  const registrarRetiradaPorCodigo = async (codigo) => {
    setLoading(true);
    setRetiradaCadastrada(null);
    try {
      const { data } = await api.put(`/rh/controle-cestas/atualizar/${codigo}`);
      if (data.error) {
        return setRetiradaCadastrada({ erro: data.error });
      }
      Toast.fire({ icon: "success", title: data.success || "Retirada registrada!", timer: 3500 });
      await buscarRetiradaPorCodigo(codigo);
      fetchRetiradas();
      carregarTotais();
    } catch (error) {
      setRetiradaCadastrada({ erro: error.response.data?.error || "Erro ao registrar a retirada." });
    } finally {
      setLoading(false);
    }
  };

  const buscarRetiradaPorCodigo = async (codigo) => {
    try {
      const { data } = await api.get(`/rh/controle-cestas/buscar/${codigo}`);
      setRetiradaCadastrada(data.item);
    } catch (error) {
      console.error(error);
    }
  };

  const handleScan = async (decodedText, decodedResult) => {
    if (scanLockedRef.current) return;
    try {
      setRetiradaCadastrada(null);
      scanLockedRef.current = true;
      await registrarRetiradaPorCodigo(decodedText);
    } finally {
      setTimeout(() => {
        scanLockedRef.current = false;
      }, SCAN_COOLDOWN_MS);
    }
  };

  const handleError = (errorMessage) => {
    if (!errorMessage.includes("NotFoundException")) {
      console.error(`QR Code Error: ${errorMessage}`);
    }
  };

  return (
    <Background>
      <Container>
        <GoBack />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            position: "relative",
          }}
        >
          <Titulo style={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>Registrar Retirada</Titulo>
          <BigButton onClick={() => setShowManualModal(true)}>Manual</BigButton>
        </div>

        <Hr />
        <ContentWrapper>
          <Panel>
            <H4 style={{ textAlign: "center" }}>Leitor de QR Code</H4>
            {hasCamera ? (
              <div id={scannerId} style={{ width: "100%", maxWidth: "300px", margin: "auto" }} />
            ) : (
              <H4 style={{ textAlign: "center", color: "red" }}>Nenhuma câmera detectada. Use o modo manual.</H4>
            )}
            <InputLabel>
              <label>Via scanner</label>
              <input value={codigo} onChange={(e) => setCodigo(e.target.value)} type="text" placeholder="Leitura do código" autoFocus />
            </InputLabel>
          </Panel>
          <Panel>
            <div>
              <div style={{ padding: 12, textAlign: "left" }}>
                {retiradaCadastrada && !retiradaCadastrada.erro ? (
                  <>
                    {retiradaCadastrada.data_retirada_cesta ? (
                      <P>
                        <strong style={{ color: "#0093e9", fontSize: "24px" }}>Cesta de natal</strong>
                      </P>
                    ) : retiradaCadastrada.data_retirada_brinquedo ? (
                      <P>
                        <strong style={{ color: "#0093e9", fontSize: "24px" }}>Brinquedo</strong>
                      </P>
                    ) : null}
                    <P>
                      <strong>Colaborador:</strong> {retiradaCadastrada.matricula}
                    </P>
                    <P>{retiradaCadastrada.nome_colaborador || retiradaCadastrada.nome}</P>
                    {retiradaCadastrada.data_retirada_cesta ? (
                      <>
                        <P>
                          <strong>Data:</strong> {formatDatesHoras(retiradaCadastrada.data_retirada_cesta)}
                        </P>
                        <Icone>
                          <Circle success={true}>
                            <IoMdCheckmark />
                          </Circle>
                        </Icone>
                      </>
                    ) : retiradaCadastrada.data_retirada_brinquedo ? (
                      <>
                        <P>
                          <strong>Data:</strong> {formatDatesHoras(retiradaCadastrada.data_retirada_brinquedo)}
                        </P>
                        <div style={{ marginTop: 12 }}>
                          <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 6 }}>
                            <tbody>
                              {retiradaCadastrada &&
                                ["brinquedo_1", "brinquedo_2", "brinquedo_3"].map((k) => {
                                  const v = retiradaCadastrada[k];
                                  if (!v) return null;
                                  return (
                                    <tr key={k}>
                                      <td style={{ padding: "6px 8px", borderBottom: "1px solid #f1f1f1" }}>{v}</td>
                                    </tr>
                                  );
                                })}
                              {!(
                                retiradaCadastrada &&
                                (retiradaCadastrada.brinquedo_1 || retiradaCadastrada.brinquedo_2 || retiradaCadastrada.brinquedo_3)
                              ) && (
                                <tr>
                                  <td style={{ padding: "6px 8px" }}>Nenhum brinquedo trazido</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <Icone>
                          <Circle success={true}>
                            <IoMdCheckmark />
                          </Circle>
                        </Icone>
                      </>
                    ) : null}
                  </>
                ) : retiradaCadastrada?.erro ? (
                  <>
                    <p style={{ textAlign: "start", color: "red", fontSize: "24px" }}>Falha</p>
                    <p>
                      {typeof retiradaCadastrada.erro === "string" && retiradaCadastrada.erro != "undefined"
                        ? retiradaCadastrada.erro
                        : "Erro ao registrar a retirada."}
                    </p>
                    <Icone>
                      <Circle success={false}>X</Circle>
                    </Icone>
                  </>
                ) : (
                  <p style={{ textAlign: "center", color: "#666" }}>Nenhuma retirada cadastrada no momento.</p>
                )}
              </div>
            </div>
          </Panel>
        </ContentWrapper>
      </Container>
      <Container>
        <Titulo>
          Retiradas {totalCestasRetiradas}/{totalCestas} Cestas - {totalBrinquedosRetirados}/{totalBrinquedos} Brinquedos
        </Titulo>
        <Hr />
        <Table>
          <thead>
            <tr>
              <th>Data/Hora</th>
              <th>Matrícula</th>
              <th>Colaborador</th>
              <th>Item Retirado</th>
            </tr>
          </thead>
          <tbody>
            {retiradas.map((item) => (
              <tr key={item.id}>
                <td>{formatDatesHoras(item.data)}</td>
                <td>{item.matricula}</td>
                <td>{item.nome}</td>
                <td>{item.tipo}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Container>
      <RegisterManual
        showModal={showManualModal}
        setShowModal={setShowManualModal}
        onSaved={async () => {
          await fetchRetiradas();
          carregarTotais();
          setShowScanner(true);
          setRetiradaCadastrada(null);
        }}
      />
    </Background>
  );
}
